/*
*  0元试用，站外
* */

import {getJSON, postJSON, getJSONP} from './myaxios';
import to_casher from '../tools/mgtv/casher'
import {click_event, error_event} from '../tools/mgtv/analysis'
import cookie from '../tools/cookie'
import {NEW_USER} from '../constant/usertype'
import {USRE_INFO_LOAD} from '../constant/eventbus'
import channels from '../constant/channels'
import get_param from "../tools/param";
import download from '../tools/mgtv/downapp'


const channel_name = {
  '9D5A10B33BCD': 'alipay',
  'ZFB34XYB49X6': 'alipaysdk',
  'QA3R2TD56U12': 'alipay',
  '837D14E0B693': 'wechat',
  '1DF81F20CD7M': 'wechat',
  '2BU45R97JD7A': 'wechat',
  'J3C03EC0249B': 'jdpay',
  'JDDUT2018515': 'jdpay',
  'C127CA0D4C66': 'ccbpay',
  'EF5C7535A51M': 'cmbpay',
  'SCENE535A51T': 'cmbpaysdk',
};


const MAX_RETRY_TIMES = 2;

export let is_result_page = get_param('from_wxpay') || get_param('from_alipay'); //是否是结果页面，结果页查询，非结果页签约

// //如果是结果页，自动调用获取结果
// if(is_result_page){
//   window.$bus.$on(USRE_INFO_LOAD,()=>{
//     getAward();
//   })
// }

//结果页面自动调用。IOS APP中是直接购买的苹果试用产品。
export function autoGetTryUseAward(product_id, days){
  if(is_result_page && !window.gact.is_ios_app){
    getTryUseAward(product_id,days);
  }
}

//获取奖品，签约后获得奖励，点击按钮调用
export function getTryUseAward(product_id,days){
  if (window.$bus.user.user_type !== NEW_USER) {
    window.$toast("本活动仅限芒果TV新用户参与哦!");
    return;
  }
  _getAward(product_id,days,0);
}

function _getAward(product_id,days,cnt = 0) {
  window.$toast.loading({message: "请稍后...", duration: 0})
  //判断是否领取过会员
  getJSON('//vipact3.api.mgtv.com/api/v1/act/ottsign/recv', {
    act_name: window.rootdata.act_name,
    ticket: window.$bus.user.ticket,
  }).then(res => {
    if (!res) {
      window.$toast.clear();
      return;
    }
    if (res.ret === 0) { //0 ,未签约/领取成功
      if (res.data.is_recv_succ) {       //领取成功
        window.$toast.clear();
        modal_get_success();
      }
      else { //查询到未签约
        if (is_result_page) { //在结果页，反复查询。
          if (cnt < MAX_RETRY_TIMES) {
            //重试中
            setTimeout(() => {
              _getAward(product_id,days,cnt + 1)
            }, 1000);
            return;
          } else {
            //超过查询次数，告知未签约
            window.$toast.clear();
            modal_no_sign(product_id,days,0);
            return;
          }
        }
        else { //在首页
          window.$toast.clear();
          window.$try_use_channel_dialog.show({
            product_id,
            days
          }); //签约弹窗
        }
      }
    }
    else if (res.ret === 412) { //已签约的状态来签约，自动解约
      window.$toast.clear();
      modal_unsign();
      is_result_page = false; // 自动把当前页面设置为首页，不再进入重试流程
      return;
    } else if (res.ret === 415) { //本次活动中已领取过了
      window.$toast.clear();
      modal_get_success()
      return;
    } else if (res.ret === 416 || res.ret === 411) { //其他同类型活动已领取，不再获取奖励
      window.$toast.clear();
      modal_only_once();
      return;
    }
    else {
      window.$toast.clear();
      window.$toast("本活动仅限芒果TV新用户参与哦!");
      return;
    }
  })
}


//去签约 $try_use_channel_dialog 弹窗中调用
export function toSign(channel,product_id) {
  window.$toast.loading({message: "请稍后...", duration: 0})
  const param = {
    channel,
    product_id,
    act_name: window.rootdata.act_name,
    ticket: window.$bus.user.ticket,
    invoker: window.gact.invoker,
    version: window.$bus.device_info.appVersion,
    mac: window.$bus.device_info.did,
    os: window.gact.os,
    return_url: '',
    t: new Date().getTime()
  };

  let return_url = window.location.href;
  //支付宝签约时需要上传回调地址。
  //WX签约时是返回本页面，且加了参数 from_wxpay=1 (微信默认，不可设置)
  if (channel === channels.alipay.renew) {
    if (return_url.indexOf('?') > 0) {
      //支付宝除了加上约定参数from_alipay=1 还需加上ticket 以防止签约的是浏览器但是结果页在支付宝中打开的
      return_url += ('&from_alipay=1&ticket=' + window.$bus.user.ticket)
    } else {
      return_url += ('?from_alipay=1&ticket=' + window.$bus.user.ticket)
    }
    param.return_url = return_url; //加入回调地址
  }else{
    if (return_url.indexOf('?') > 0) {
      //微信，在APP中展示的完成页是我拼接的，而在微信中的完成页是微信拼接并跳转的，为了保持一致，仿微信跳转地址
      return_url += ('&from_wxpay=1&ticket=' + window.$bus.user.ticket)
    } else {
      return_url += ('?from_wxpay=1&ticket=' + window.$bus.user.ticket)
    }
    //微信中不用传 return_url ，传了微信也不理会
  }

  getJSONP('//as.mgtv.com/client/pay/autorenew_sign', param).then(res => {
    window.$toast.clear();
    if (!res) {
      window.$toast("请求超时，请重试");
      return;
    }
    console.log('sign renew', res);
    if (res.status === '200') {
      if(window.gact.is_app){

        if(window.gact.is_android){
          const iapParams = {
            // 这个是活动统计那边的，有就传，没就留空
            pagename: '',
            actid: window.gact.source,
            clocation: 1,
            p: '0', // 产品包id
            pp: '0', // 价格
            c: channel, // 渠道号
            o: "0", // 支付订单id,这里为了避免出现结果页使用的以noas-开头的业务订单
            videoId: '',
            iapType: '',
            payUrl: res.data.url,
            sdkData:  '',
            t: channel_name[channel],
            expver: '',
            completed_url: ''
          };

          // //安卓APP中，微信签约不显示完成页面，借助APP完成。而支付宝签约会在支付宝中展示完成页（下单时传入）。
          if(channel === channels.wechat.renew){
            iapParams.completed_url = return_url;
          }

          const iapParamStr = JSON.stringify(iapParams)
          console.log('唤起支付', iapParamStr)
          MgtvApi.getIap(iapParams);
        }
      }else{
        //app外
        if (channel === channels.alipay.renew) {
          window.location.href = 'alipays://platformapi/startapp?appId=20000067&url=' + encodeURIComponent(res.data.url)
        } else if(channel === channels.wechat.renew) {
          window.location.href = res.data.url;
        }
      }
    } else {
      window.$toast(res.msg);
    }
  })
}




//领取成功
export function modal_get_success() {
  click_event('您已领取成功')
  window.$act_alert_dialog.show({
    title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">您已领取成功，快前往芒果TV享用吧！</div>`,
    button: '确定'
  }).then(res => {
    download();
    // if (!gact.disable_download) {
    //   download();
    // }
  }).catch(res => {
  })
}

//同类型活动只可参与一次
export function modal_only_once() {
  click_event('已参加过同类型活动')
  window.$act_alert_dialog.show({
    title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">您的当前芒果TV账号已参加过同类型新用户优惠或福利活动，请勿重复参加~</div>`,
    button: '确定'
  }).then(res => {

  }).catch(res => {
  })
}



export function modal_no_sign(product_id,days) {
  window.$act_alert_dialog.show({
    title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">暂未查询到您的开通自动续费信息，请稍后重试！</div>`,
    button: '重新查询'
  }).then(res => {
    _getAward(product_id,days,0); //继续查询
  }).catch(res => {
    is_result_page = false; //可以重新开始签约
  })
}


export function modal_unsign() {
  window.$act_alert_dialog.show({
    title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">您的支付账号已经参加过此活动，请勿重复参加~~</div>`,
    button: '确定'
  }).then(res => {

  }).catch(res => {
  })
}




// WEBPACK FOOTER //
// ./src/api/tryUse.js